function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Base from './base';
import Segments from './segments';
import MCPOption from './multiple_choice_poll_option';

var SegmentingOption = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SegmentingOption, _Base);

  function SegmentingOption() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SegmentingOption.prototype;

  _proto.initialize = function initialize() {
    _Base.prototype.initialize.apply(this, arguments);

    this.set({
      segments: new Segments(this.get('options')),
      mcpOption: new MCPOption(this.get('this_option'))
    });
    this.get('segments').segmentingOption = this;
  };

  _proto.parse = function parse(json, options) {
    if (json == null) {
      json = {};
    }

    if (!this.get('segments')) {
      this.set({
        segments: new Segments()
      });
    }

    if (json.options) {
      this.get('segments').reset(json.options, options);
    }

    if (!this.get('mcpOption')) {
      this.set({
        mcpOption: new MCPOption()
      });
    }

    if (json.this_option) {
      this.get('mcpOption').set(json.this_option, options);
    }
    /*
     * TODO: Uncomment this once the viz project doesn't reference this attribute directly.
     * delete json.options
     */


    return json;
  };

  _proto.responseCount = function responseCount(opts) {
    if (opts == null) {
      opts = {};
    }

    if (opts.includeNonResponses == null) {
      opts.includeNonResponses = false;
    }

    var count = this.get('total_results');

    if (!opts.includeNonResponses) {
      count -= this.get('no_responses');
    }

    return count;
  };

  _proto.maxResponseCount = function maxResponseCount(opts) {
    if (opts == null) {
      opts = {};
    }

    return this.collection.maxResponseCount(opts);
  };

  _proto.percentOfMaxResponseCount = function percentOfMaxResponseCount(opts) {
    if (opts == null) {
      opts = {};
    }

    return this.responseCount(opts) / this.maxResponseCount(opts);
  };

  return SegmentingOption;
}(Base);

export { SegmentingOption as default };